import baseService from "@common/externos/services/base.service";
import store from "@common/store/store";

const tbRoute = window.api_routes.smarAPD_Tributario_Domain;
const commonRoute = window.api_routes.smarAPD_Common;

let http = baseService(store, tbRoute);

let controller = "/MovimentacaoExterno/";

const apiDef = {

  verificaDocumentoLiberadoSolicitacao() {
    return http.post(controller + "VerificaDocumentoLiberadoSolicitacao");
  },

  pesquisarSolicitacaoDocumentoCpfCnpj(data, tokenRecaptcha) {
    return http.post(
      controller + "solicitacaodocumento/pesquisarporcpfcnpj",
      {CpfCnpj: data},
      tokenRecaptcha
    );
  },

  suggestionSolicitarDocumento(busca, parameters) {
    return http.get(controller + 'tipodocumento/suggestion', {
      params: {
        busca,
        parameters: parameters,
      },
      noLoading: true,
    });
  },

  pesquisarSolicitacaoDocumento(tokenRecaptcha, data) {
    return http.post(
      controller + "solicitacaodocumento/pesquisar",
      tokenRecaptcha,
      data
    );
  },
  postSolicitacaoDocumento(data){
    return http.post(controller + "solicitacaodocumento", data);
  },
};

export default apiDef;
